module.exports = __webpack_public_path__ + "static/media/Leon.c9fd1677.png";